<template>
  <div class="wrapper team1">
    <div class="breadcrumb">{{$t("main.nav[0].list[1].title")}}</div>
    <div class="container">
      <div class="bg">
        <section class="team item1" id="sz1">
          <img class="img" src="~assets/main/estate/team/team2-01.jpg"/>
          <div class="des">
            <happy-scroll color="rgba(0,0,0,0.5)" size="5" class="news-scroll" :resize="true" hide-horizontal>
              <!-- 内层盒子——内容区 -->
              <div class="con">
                <div class="title">{{$t("main.des[0].list[8].title")}}</div>
                <div class="text" v-html='$t("main.des[0].list[8].text")'></div>
              </div>
            </happy-scroll>
          </div>
        </section>
        <section class="item2"  id="sz2">
          <div class="img"><img src="~assets/main/estate/team/team2-02.jpg"/></div>
          <div class="des">
            <happy-scroll color="rgba(0,0,0,0.5)" size="5" class="news-scroll" :resize="true" hide-horizontal>
              <!-- 内层盒子——内容区 -->
              <div class="con">
                <div class="title">{{$t("main.des[0].list[9].title")}}</div>
                <div class="text" v-html='$t("main.des[0].list[9].text")'></div>
              </div>
            </happy-scroll>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'doubleSwiper',
  data () {
    return {
      resize: true
    }
  },
  mounted () {
  },
  beforeMount () {
  },
  computed: {
  },
  created () {
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .des
    width 100%
    margin-top 30px
    height 120px
    height 120px
    .text
      padding-bottom 30px
    .title
      font-size 20px
      font-weight bold
      line-height 32px
    .des
      b
        font-weight bold
  .wrapper
    width 78%
    font-size 15px
    line-height 26px
    .breadcrumb:before
      afterTop()
      width 4px
      height 60%
      top 20%
      background $navBgColor2
    .breadcrumb:after
      afterBottom()
      borderBottom()
      width 100%
      opacity 0.2
    .breadcrumb
      cn()
      font-size 24px
      font-weight bold
      padding 5px 0 5px 20px
      position relative
      margin-bottom 45px
      b
        font-weight normal
        margin-left 10px
    .container
      padding-left 30px
      box-sizing border-box
      .bg
        background url("~assets/main/estate/team/team2-bg.png")
        fullBg()
        background-position right 0
        .item1
          width 65%
          position relative
          .des
            position absolute
            top 100%
            z-index 2
        .item2
          position relative
          width 100%
          .img
            width 65%
            margin 20% auto 0
          .des
            width 65%
            margin 5% auto 0
            box-sizing border-box
            height 150px
  @media screen and (max-width: 1920px) {
    .des {
      height 90px!important
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/main/components/Team2.vue